import { type LocalesKey } from 'common/types/types';
import PageNotFoundIcon from 'assets/page-not-found.png';

export interface ErrorPageProps {
  headingLocaleKey: LocalesKey;
  bodyText?: LocalesKey | string;
  buttonLocaleKey?: LocalesKey;
  imageSrc?: string;
  isFullPage?: boolean;
  hasGoToHomepage?: boolean;
}

export const genericErrorProps: ErrorPageProps = {
  headingLocaleKey: 'STR_SOMETHING_WENT_WRONG',
  bodyText: 'STR_SERVER_CONNECTION_ERROR',
  buttonLocaleKey: 'STR_RELOAD',
  isFullPage: true,
};

export const pageNotFoundProps: ErrorPageProps = {
  imageSrc: PageNotFoundIcon,
  headingLocaleKey: 'STR_PAGE_NOT_FOUND',
  bodyText: 'STR_SORRY_WE_CANT_FIND_PAGE',
  buttonLocaleKey: 'STR_GO_TO_HOME',
  hasGoToHomepage: true,
};
